import {Injectable} from '@angular/core';
import {ComplyMessageApi} from '../api/comply-message.api';
import { CplItemType } from '../model/enum/cpl-item-type.enum';
import {MessageRequest} from '../model/message-request.model';
@Injectable()
export class ComplyMessageService {
    
    constructor(private complyMessageApi: ComplyMessageApi) { }

    getMessages = (offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string, start?:string, end?:string) => 
        this.complyMessageApi.getMessages(offset, limit, orderBy, ascending, searchBy, start, end);


    getHistoryMessages = (
        { historyId, typeId, offset, limit, } : 
        { historyId: string, typeId: CplItemType, offset?: number, limit?: number }
    ) => this.complyMessageApi.getHistoryMessages({ historyId, typeId, offset, limit });

    getMessage = (messageRecipientId: string) => this.complyMessageApi.getMessage(messageRecipientId);

    getMessageTransmissionDetails = (messageRecipientId: string) => this.complyMessageApi.getMessageTransmissionDetails(messageRecipientId);

    sendMessage = (message: MessageRequest) => this.complyMessageApi.sendMessage(message);

    nudge = (message: MessageRequest) => this.complyMessageApi.nudge(message);

    bulkNudge = (messages: MessageRequest) => this.complyMessageApi.nudge(messages);
}